import { Accordion, Button, Stack, Text } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { LayoutCard } from "@/components/layouts/LayoutCard";

export interface FAQ {
  question: string;
  answer: string;
}

export const SupportComponent = ({ faqContent }: { faqContent: Array<FAQ> }) => {
  const navigate = useNavigate();

  return (
    <LayoutCard
      title="Support Center"
      subtitle="Find answers to common questions or contact our support team."
    >
      <Stack gap="lg">
        <Accordion variant="separated" radius="md">
          {faqContent.map((faq) => (
            <Accordion.Item key={faq.question} value={faq.question}>
              <Accordion.Control>{faq.question}</Accordion.Control>
              <Accordion.Panel>{faq.answer}</Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>

        <Stack gap="sm">
          <Text>Need more help?</Text>
          <Button onClick={() => navigate({ to: "/feedback" })}>
            Contact Support
          </Button>
        </Stack>
      </Stack>
    </LayoutCard>
  );
};

export default SupportComponent;
